import { useRouteContext } from '@tanstack/react-router';
import type { PermissionsResponseDTO } from '@tempo-io/id-dto';
import { usePublishedContext } from '@/components/views/published/PublishedContext';

export const usePermissionsWithPublished = (): Partial<PermissionsResponseDTO> | undefined => {
  const publishedContext = usePublishedContext();
  const routeContext = useRouteContext({ strict: false });

  if (publishedContext !== null) return undefined;
  return routeContext.permissions;
};
